export default __webpack_public_path__ + "static/media/saiteja_headshot.c902dee7.png";